// Tabbed before/after showcase. Tabs, dots, and prev/next chevrons all
// activate the matching media panel and heading.
class HomeCuratedTabs extends HTMLElement {
  connectedCallback() {
    this.media = Array.from(this.querySelectorAll('.home-curated__media'));
    this.headings = Array.from(this.querySelectorAll('.home-curated__heading'));
    this.tabs = Array.from(this.querySelectorAll('.home-curated__tab'));
    this.dots = Array.from(this.querySelectorAll('.home-curated__dot'));
    this.navs = Array.from(this.querySelectorAll('.home-curated__nav'));
    this.count = this.media.length;
    this.current = 0;

    [...this.tabs, ...this.dots].forEach((el) => {
      el.addEventListener('click', () => this.select(Number(el.dataset.index)));
    });

    this.navs.forEach((el) => {
      el.addEventListener('click', () => {
        const dir = Number(el.dataset.dir) || 1;
        this.select((this.current + dir + this.count) % this.count);
      });
    });
  }

  select(index) {
    this.current = index;
    this.media.forEach((el) => el.toggleAttribute('data-active', Number(el.dataset.index) === index));
    this.headings.forEach((el) => el.toggleAttribute('data-active', Number(el.dataset.index) === index));
    this.tabs.forEach((el) => el.setAttribute('aria-selected', Number(el.dataset.index) === index ? 'true' : 'false'));
    this.dots.forEach((el) => el.setAttribute('aria-current', Number(el.dataset.index) === index ? 'true' : 'false'));
  }
}

if (!customElements.get('home-curated-tabs')) {
  customElements.define('home-curated-tabs', HomeCuratedTabs);
}
